<h1>Results</h1>

<ng-content />

@if (store.results$ | async; as results) {
  <div class="flex flex-row gap-4">
    @if (store.editMode$ | async) {
      <button mat-stroked-button (click)="store.editColumns()">
        Edit Columns
      </button>
    }

    <pt-download-report
      [data]="csvData$ | async"
      [csvTranslator]="csvTranslator$ | async"
    />
    <span class="flex grow"></span>

    <div class="flex flex-row gap-4">
      <div class="flex flex-col">
        <span class="text-xs opacity-50">
          {{ results.filteredCount }} selected out of
          {{ results.allCount }} records
        </span>
      </div>
      <button mat-stroked-button (click)="store.resetActiveFilters()">
        Reset All Filters
      </button>
    </div>
  </div>
}
<div class="results-table">
  <pr-report-builder-table />
</div>
